import { module as Module } from 'modujs'

export default class extends Module {
  constructor(m) {
    super(m)

    this.events = {
      mouseenter: 'open',
      mouseleave: 'close',
    }
  }

  init() {
    this.link = this.el.dataset.link
  }

  open() {
    this.call('show', this.link, 'NavHover')
  }

  close() {
    this.call('hide', this.link, 'NavHover')
  }
}
